
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".549","d":"M20 0H4a4 4 0 00-4 4v16a4 4 0 004 4h16a4 4 0 004-4V4a4 4 0 00-4-4z","fill":"#eeeefe"}}),_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"mask0_738_2885","maskUnits":"userSpaceOnUse","x":"4","y":"4","width":"16","height":"16"}},[_c('path',{attrs:{"d":"M20 4H4v16h16V4z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#mask0_738_2885)"}},[_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"mask1_738_2885","maskUnits":"userSpaceOnUse","x":"5","y":"5","width":"14","height":"14"}},[_c('path',{attrs:{"d":"M19 5H5v14h14V5z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#mask1_738_2885)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#5858EC"}},[_c('path',{attrs:{"d":"M7.37 6.3A1.07 1.07 0 006.3 7.37v9.25a1.07 1.07 0 001.07 1.07h9.26a1.07 1.07 0 001.07-1.07V9.19h-.01V7.37a1.071 1.071 0 00-1.07-1.07H7.37zm11.62 2.47v-1.4A2.37 2.37 0 0016.62 5H7.37A2.37 2.37 0 005 7.37v9.25a2.37 2.37 0 002.37 2.37h9.26A2.37 2.37 0 0019 16.62V8.77h-.01z"}}),_c('path',{attrs:{"d":"M10.06 8.54h3.87a1.523 1.523 0 011.52 1.52v3.87a1.523 1.523 0 01-1.52 1.52h-3.87a1.523 1.523 0 01-1.52-1.52v-3.87a1.523 1.523 0 011.52-1.52zm0 1.3a.221.221 0 00-.22.22v3.87a.221.221 0 00.22.22h3.87a.221.221 0 00.22-.22v-3.87a.221.221 0 00-.22-.22h-3.87z"}})])])])
          )
        }
      }
    